const indexItems = [
  {
    letter: 'A',
    title: '爱在黎明破晓时',
    tag: '恋爱·韩漫',
    desc: '一段跨越时空的浪漫爱情故事，画风唯美，剧情温暖治愈。',
  },
  {
    letter: 'B',
    title: '不败战神',
    tag: '热血·国漫',
    desc: '少年战神转世重生，以无敌之姿横扫诸天万界，热血战斗不容错过。',
  },
  {
    letter: 'C',
    title: '穿越异界成为剑圣',
    tag: '奇幻·日漫',
    desc: '普通高中生穿越异世界，觉醒最强剑术天赋，踏上剑圣之路。',
  },
  {
    letter: 'D',
    title: '都市灵异事件簿',
    tag: '悬疑·国漫',
    desc: '城市中隐藏着不为人知的灵异事件，少年侦探揭开层层谜团。',
  },
  {
    letter: 'F',
    title: '反派千金的重生',
    tag: '奇幻·韩漫',
    desc: '女主重生为小说中的反派千金，利用先知优势改写命运。',
  },
  {
    letter: 'H',
    title: '花与剑与法兰西',
    tag: '历史·国漫',
    desc: '19世纪法国为背景的历史漫画，浪漫与谍战交织的宏大叙事。',
  },
  {
    letter: 'S',
    title: '死神代理人',
    tag: '热血·日漫',
    desc: '少年被选为死神代理人，在生死之间守护人间的秩序与和平。',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            漫画主题索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            按首字母快速浏览漫画作品，发现更多好看的漫画
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-4 md:gap-6 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <span className="text-primary-600 font-heading font-bold text-lg md:text-xl">
                  {item.letter}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
              <span className="w-8 h-8 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0">
                <i className="ri-arrow-right-s-line text-xl"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}